import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolizzaViewComponent } from './polizza-view/polizza-view.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { RouterModule } from '@angular/router';
import { PolizzaViewRoutingModule } from './polizza-view-routing.module';

@NgModule({
  declarations: [PolizzaViewComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    RouterModule,
    ResourcefulIndexModule,
    PolizzaViewRoutingModule,
  ]
})
export class PolizzaViewModule { }
